// JavaScript Document
//components/configuration/standard/forms/beacon.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function Beacon(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, timing, dim, alternate, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	const [wigwag, setWigwag] = React.useState({
		wigOn:500,
		wigOff: 0,
		wagOn:500,
		wagOff:0
	});
	const [useDim, setUseDim] = React.useState(true);
	const [useAlternate, setUseAlternate] = React.useState(true);
	//Local constant for maximum value
	const max = 65535;
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setUseDim(dim ? true : false);
			setUseAlternate(alternate ? true : false);
			setCid(id);
			setWigwag({
				wigOn:timing[0],
				wigOff:timing[1],
				wagOn:timing[2],
				wagOff:timing[3]
			});
			
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (newTiming, newDim, newAlternate) => {
		if(onChange){
			console.log('Updating parent');
			onChange([newTiming.wigOn, newTiming.wigOff, newTiming.wagOn, newTiming.wagOff], newDim, newAlternate);
		}
	}
	

	
	//handle change timing value
	const handleChangeTiming = (e) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		let newWigwag = Object.assign({}, wigwag);
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > max){
			value = max;
		}
		newWigwag[setting] = value;
		setWigwag(newWigwag);
		handleUpdateParent(newWigwag, useDim, useAlternate);
	}
	
	//handle change dim enable
	const handleChangeDim = (e) => {
		let value = e.target.checked;
		setUseDim(value);
		handleUpdateParent(wigwag, value, useAlternate);
	}
	
	//handle change alternate enable
	const handleChangeAlternate = (e) => {
		let value = e.target.checked;
		setUseAlternate(value);
		handleUpdateParent(wigwag, useDim, value);
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Beacons" />
	  		<CardContent className={classes.advancedContent}>
				<table>
				<tr>
				<td>
				<FormGroup column>
					<FormControlLabel
						control={<Switch checked={useDim} onChange={handleChangeDim} />}
						label={(useDim ? 'Dim' : "Max")+' Brightness'}
					/>
					<FormControlLabel
						control={<Switch checked={useAlternate} onChange={handleChangeAlternate} />}
						label={(useAlternate ? "Alternate" : "Synchronize")}
					/>
				</FormGroup>
				</td>
				</tr>
				<tr>
				<td>
				<Box>
					<Typography>Channel 1</Typography>
	  				<TextField 
							id="wigOn" 
							name="wigOn"
							label="On"
							value={wigwag.wigOn.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
					<TextField 
							id="wigOff" 
							name="wigOff"
							label="Off"
							value={wigwag.wigOff.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
				</Box>
				</td>
				</tr>
				<tr>
				<td>
				<Box>
					<Typography>Channel 2</Typography>
	  				<TextField 
							id="wagOn" 
							name="wagOn"
							label="On"
							value={wigwag.wagOn.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
					<TextField 
							id="wagOff" 
							name="wagOff"
							label="Off"
							value={wigwag.wagOff.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeTiming}
							type="number" 
							inputProps={{min: '0', max:max.toString(), step:'50', style: {textAlign:'center'}}}
					/>
				</Box>
				</td>
				</tr>
				</table>
	  		</CardContent>
	  	</Card>
  );
}
